import Swiper from "swiper";
import { A11y, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

document.querySelectorAll(".related-posts").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Pagination],
    slidesPerView: 1,
    spaceBetween: 24,
    speed: 500,
    simulateTouch: false,
    threshold: 25,
    pagination: {
      el: el.querySelector(".slider-pagination"),
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 36,
      },
    },
  });
});
